(function(){
  var $=function(s,c){return (c||document).querySelector(s)},$$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
  var money=function(c){return (c/100).toLocaleString('cs-CZ',{minimumFractionDigits:0,maximumFractionDigits:0})+' Kč'};

  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-drawer-open]');if(t){$('.mdrawer').classList.add('is-open');document.body.style.overflow='hidden';}
    if(e.target.closest('[data-drawer-close]')||e.target.classList.contains('mdrawer__bg')){var d=$('.mdrawer');if(d){d.classList.remove('is-open');document.body.style.overflow='';}}
  });

  // predictive search
  var si=$('[data-psearch-input]');
  if(si){var box=$('.psearch'),tmr;
    si.addEventListener('input',function(){clearTimeout(tmr);var q=si.value.trim();if(q.length<2){box.classList.remove('is-open');return;}
      tmr=setTimeout(function(){
        fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function(r){return r.json()}).then(function(d){
          var items=(d.resources.results.products||[]);
          if(!items.length){box.innerHTML='<div style="padding:14px;color:#5b6b7d;font-size:.85rem">Žádné výsledky</div>';box.classList.add('is-open');return;}
          box.innerHTML=items.map(function(p){
            var img=p.featured_image?p.featured_image.url:p.image;
            return '<a href="'+p.url+'">'+(img?'<img src="'+img+'" alt="'+p.title+'" loading="lazy">':'')+'<span><span class="ps-t">'+p.title+'</span><span class="ps-p">'+(p.price?money(p.price):'')+'</span></span></a>';
          }).join('');box.classList.add('is-open');
        });
      },220);
    });
    document.addEventListener('click',function(e){if(!e.target.closest('.hdr__search')&&box){box.classList.remove('is-open');}});
  }

  // gallery
  $$('[data-gallery]').forEach(function(g){
    var main=$('[data-gallery-main] img',g);
    $$('[data-gallery-thumb]',g).forEach(function(b){
      b.addEventListener('click',function(){
        main.removeAttribute('srcset');main.removeAttribute('sizes');
        main.src=b.dataset.full;var ti=b.querySelector('img');if(ti)main.alt=ti.alt;
        $$('[data-gallery-thumb]',g).forEach(function(x){x.classList.remove('is-active')});b.classList.add('is-active');
      });
    });
  });

  // quantity
  document.addEventListener('click',function(e){
    var m=e.target.closest('[data-qty]');if(!m)return;
    var inp=$('input',m.parentNode),v=parseInt(inp.value,10)||1;
    v+= (m.dataset.qty==='up'?1:-1);if(v<1)v=1;inp.value=v;
    inp.dispatchEvent(new Event('change',{bubbles:true}));
  });

  // variant selection
  var form=$('[data-product-form]');
  if(form){
    var data=window.__variants||[],optInputs=$$('[data-opt]',form),idField=$('[name="id"]',form),
        priceEl=$('[data-price]'),cmpEl=$('[data-compare]'),atcBtn=$('[data-atc]'),stockEl=$('[data-stock]'),satcId=$('[data-satc-id]');
    function selected(){return optInputs.filter(function(i){return i.checked||i.tagName==='SELECT'}).reduce(function(a,i){a[i.dataset.opt]=i.tagName==='SELECT'?i.value:i.value;return a},{})}
    function chosenValues(){var o={};$$('[data-opt]',form).forEach(function(i){if(i.tagName==='SELECT'){o[i.dataset.opt]=i.value}else if(i.checked){o[i.dataset.opt]=i.value}});return o}
    function update(){
      var sel=chosenValues();
      var match=data.find(function(v){return v.options.every(function(val,idx){return val===sel['option'+(idx+1)]})});
      if(!match)return;
      idField.value=match.id;if(satcId)satcId.value=match.id;
      if(priceEl)priceEl.textContent=money(match.price);
      if(cmpEl){if(match.compare_at_price>match.price){cmpEl.textContent=money(match.compare_at_price);cmpEl.style.display='';}else{cmpEl.style.display='none';}}
      if(atcBtn){atcBtn.disabled=!match.available;atcBtn.textContent=match.available?atcBtn.dataset.add:atcBtn.dataset.sold;}
      if(stockEl&&match.inventory_quantity!=null&&match.inventory_quantity>0&&match.inventory_quantity<=8){stockEl.style.display='';$('[data-stock-n]').textContent=match.inventory_quantity;}else if(stockEl){stockEl.style.display='none';}
    }
    optInputs.forEach(function(i){i.addEventListener('change',update)});update();

    var gw=$('[data-giftwrap]',form);
    form.addEventListener('submit',function(e){
      if(!gw||!gw.checked||!gw.getAttribute('data-giftwrap'))return;
      e.preventDefault();
      var qty=parseInt($('[name="quantity"]',form).value,10)||1;
      var items=[{id:idField.value,quantity:qty,properties:{'Dárkové balení':'Ano'}},{id:gw.getAttribute('data-giftwrap'),quantity:1}];
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
        .then(function(){window.location.href='/cart';});
    });
  }

  // sticky atc
  var satc=$('.satc'),atcAnchor=$('[data-atc]');
  if(satc&&atcAnchor){window.addEventListener('scroll',function(){
    var r=atcAnchor.getBoundingClientRect();satc.classList.toggle('is-on',r.bottom<0);
  },{passive:true});}

  // back to top
  var btt=$('.btt');
  if(btt){window.addEventListener('scroll',function(){btt.classList.toggle('is-on',window.scrollY>600)},{passive:true});
    btt.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'})});}

  // shipping progress bar (cart total via data attr threshold)
  var ship=$('[data-ship]');
  if(ship){var thr=parseInt(ship.dataset.ship,10),cur=parseInt(ship.dataset.cart,10)||0;
    var pct=Math.min(100,cur/thr*100);var fill=$('.ship__fill',ship);if(fill)fill.style.width=pct+'%';
    var lbl=$('[data-ship-label]',ship);if(lbl){if(cur>=thr){lbl.textContent='Máte dopravu ZDARMA! 🎣';}else{lbl.textContent='Do dopravy zdarma zbývá '+money(thr-cur);}}
  }

  // countdown
  $$('[data-countdown]').forEach(function(el){
    var end=Date.now()+ (parseInt(el.dataset.countdown,10)||0)*1000;
    function tick(){var d=Math.max(0,end-Date.now()),h=Math.floor(d/36e5),m=Math.floor(d%36e5/6e4),s=Math.floor(d%6e4/1e3);
      el.innerHTML='<div><b>'+('0'+h).slice(-2)+'</b><small>hodin</small></div><div><b>'+('0'+m).slice(-2)+'</b><small>minut</small></div><div><b>'+('0'+s).slice(-2)+'</b><small>sekund</small></div>';}
    tick();setInterval(tick,1000);
  });

  // discount popup after 8s + exit intent
  var pop=$('[data-popup="discount"]');
  if(pop&&!localStorage.getItem('fa_pop')){
    var open=function(){pop.classList.add('is-open');localStorage.setItem('fa_pop','1')};
    setTimeout(open,8000);
    document.addEventListener('mouseout',function(e){if(e.clientY<10&&!localStorage.getItem('fa_pop'))open();});
  }
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-popup-close]')||e.target.classList.contains('modal__bg')){var m=e.target.closest('.modal');if(m)m.classList.remove('is-open');}
  });

  // cookie banner
  var ck=$('.cookie');
  if(ck&&!localStorage.getItem('fa_cookie')){ck.classList.add('is-on');
    $$('[data-cookie]',ck).forEach(function(b){b.addEventListener('click',function(){localStorage.setItem('fa_cookie',b.dataset.cookie);ck.classList.remove('is-on');});});
  }

  // wishlist
  var WL='fa_wishlist';
  function wl(){try{return JSON.parse(localStorage.getItem(WL)||'[]')}catch(e){return[]}}
  function setWl(a){localStorage.setItem(WL,JSON.stringify(a))}
  $$('[data-wish]').forEach(function(b){
    var id=b.dataset.wish;if(wl().indexOf(id)>-1)b.classList.add('is-on');
    b.addEventListener('click',function(e){e.preventDefault();var a=wl(),i=a.indexOf(id);
      if(i>-1){a.splice(i,1);b.classList.remove('is-on')}else{a.push(id);b.classList.add('is-on')}setWl(a);});
  });

  // recently viewed
  var rvId=$('[data-rv-current]');
  if(rvId){var K='fa_rv',a;try{a=JSON.parse(localStorage.getItem(K)||'[]')}catch(e){a=[]}
    var h=rvId.dataset.rvCurrent;a=a.filter(function(x){return x!==h});a.unshift(h);a=a.slice(0,8);localStorage.setItem(K,JSON.stringify(a));}
  var rvWrap=$('[data-rv]');
  if(rvWrap){var K2='fa_rv',list;try{list=JSON.parse(localStorage.getItem(K2)||'[]')}catch(e){list=[]}
    list=list.filter(function(h){return h!==rvWrap.dataset.rv});
    if(!list.length){rvWrap.closest('[data-rv-section]').style.display='none';}
    else{Promise.all(list.slice(0,6).map(function(h){return fetch('/products/'+h+'.js').then(function(r){return r.ok?r.json():null}).catch(function(){return null})}))
      .then(function(ps){ps=ps.filter(Boolean);if(!ps.length){rvWrap.closest('[data-rv-section]').style.display='none';return;}
        rvWrap.innerHTML=ps.map(function(p){var img=p.featured_image||(p.images&&p.images[0]);
          return '<a class="pcard" href="'+p.url+'"><div class="pcard__img">'+(img?'<img src="'+img+'" alt="'+p.title+'" loading="lazy">':'')+'</div><div class="pcard__body"><span class="pcard__t">'+p.title+'</span><span class="pcard__price"><b>'+money(p.price)+'</b></span></div></a>';
        }).join('');});
    }
  }

  // scroll reveal + header scroll (Háček)
  (function(){
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var sel='.sec__head,.ccard,.pcard,.ftg__c,.trust__i,.ctable,.news,.acard,.stat,.lp__ben,.pdp__block';
    var nodes=$$(sel).filter(function(el){return !el.closest('[data-no-reveal]')});
    if(nodes.length){
      if(reduce||!('IntersectionObserver' in window)){nodes.forEach(function(el){el.classList.add('in')});}
      else{
        var seen=[];
        nodes.forEach(function(el){el.setAttribute('data-reveal','');var p=el.parentNode,r=null;for(var i=0;i<seen.length;i++){if(seen[i].p===p){r=seen[i];break;}}if(!r){r={p:p,n:0};seen.push(r);}el.style.setProperty('--rd',Math.min(r.n,6)*70+'ms');r.n++;});
        var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
        nodes.forEach(function(el){io.observe(el)});
      }
    }
    var hdr=$('.hdr');
    if(hdr){var t=false;window.addEventListener('scroll',function(){if(!t){t=true;requestAnimationFrame(function(){hdr.classList.toggle('is-scrolled',window.scrollY>8);t=false;});}},{passive:true});}
  })();


  // filtr collapsed na mobilu
  (function(){var f=document.querySelector('.filters');if(f&&window.innerWidth<768)f.removeAttribute('open');})();

})();
